import React from "react";
import styles from "./styles.module.scss";
// Components
import StatusButton from "../StatusButton";
// Utils
import { getUserIsManagerOrAdmin } from "../../Services/Utils";
// Hooks
import { useGetServiceUserList } from "../../Services/Hooks";
import { useAmplitudeTracking } from "Services/Hooks/useAmplitudeTracking";
import { useAppSelector } from "State/hooks";
import { hasNoActiveHubs } from "Services/Utils/hasNoActiveHubs";

const DashboardNotificationsSection = ({
  setSelectedFilter,
  setSelectedTab,
}) => {
  const user = useAppSelector((state) => state.user);
  const userRoles = user?.roles;

  // number awaiting install
  const { serviceUsersToDisplay } = useGetServiceUserList("incomplete", "");

  const numAwaitingInstall =
    serviceUsersToDisplay?.length > 0
      ? `${serviceUsersToDisplay?.length} users awaiting install`
      : "No users awaiting install";

  // staff
  const shouldSeeUnassignedStaff = getUserIsManagerOrAdmin(userRoles);
  const staff = useAppSelector((state) => state.staff);

  // no of staff without service user assigned to them (number of hubs)

  const unassignedStaff = staff.filter(hasNoActiveHubs);

  const numUnassignedStaff = unassignedStaff.length;

  const staffText =
    numUnassignedStaff > 0
      ? `${numUnassignedStaff} staff members need to be assigned a service user`
      : "No staff members need to be assigned a service user";

  // tracking
  const track = useAmplitudeTracking();

  const shouldShowServiceUsersToDisplay = serviceUsersToDisplay?.length > 0;

  const shouldShowUnAssignedStaff =
    shouldSeeUnassignedStaff && numUnassignedStaff > 0;

  return (
    <div className={styles.notifications_container}>
      <div className={styles.notifications_header_container}>
        <div className={styles.notifications_title_text}>Notifications</div>
      </div>
      {shouldShowServiceUsersToDisplay ? (
        <StatusButton
          text={numAwaitingInstall}
          onClick={() => {
            setSelectedTab("users");
            setSelectedFilter("incomplete");
          }}
          onTrack={() =>
            track("Service User Browsing", {
              action_type: "filter",
              filter_type: "installation_incomplete",
              location: "dashboard",
              button_type: "awaiting_install",
            })
          }
        />
      ) : null}
      {shouldShowUnAssignedStaff ? (
        <StatusButton
          text={staffText}
          onTrack={() => {
            track("Service User Browsing", {
              action_type: "filter",
              tab: "staff",
              location: "dashboard",
              button_type: "unassigned_staff",
            });
          }}
          onClick={() => setSelectedTab("staff")}
        />
      ) : null}
      {!shouldShowUnAssignedStaff && !shouldShowServiceUsersToDisplay ? (
        <div className={styles.no_more_notifications_text}>
          No notifications
        </div>
      ) : null}
    </div>
  );
};

export default DashboardNotificationsSection;
